import { FC, HTMLAttributes, ReactNode, useMemo } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames/bind';

interface IProps {
    weight?: 'medium' | 'semibold' | 'bold' | 'thin';
    variant?:
        | 'h1'
        | 'h2'
        | 'h3'
        | 'h4'
        | 'h5'
        | 'body1' //body 20
        | 'body2' // body 18
        | 'body3' // body 16
        | 'body4' // body 14
        | 'caption1' // caption
        | 'button_medium'
        | 'button_small'
        | 'button_tiny'
        | 'label1' // label 14
        | 'label2'; //label 16
    children?: ReactNode;
    fz?: number;
    lh?: string;
    fw?: number;
    alignment?: 'left' | 'center' | 'right';
    className?: string;
    style?: React.CSSProperties;
}

const cx = classNames.bind(styles);

const Typography: FC<IProps & HTMLAttributes<HTMLParagraphElement>> = ({
    variant = 'default',
    children,
    style,
    className,
    alignment = 'left',
    fz,
    lh,
    weight,
    fw,
    ...props
}) => {
    const rootStyles = useMemo(
        () => cx([styles.root, variant, weight, className, alignment]),
        [className, variant, weight, alignment]
    );

    return (
        <p
            className={rootStyles}
            style={{
                fontSize: fz,
                lineHeight: lh,
                fontWeight: fw,
                ...style
            }}
            {...props}>
            {children}
        </p>
    );
};

export default Typography;
